import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = 'https://potluckpal-production.up.railway.app';

export const Landing = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmed)) {
      setStatus('error');
      setErrorMsg('Please enter a valid email address.');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch(`${API_BASE}/api/waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: trimmed }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Something went wrong');
      }
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <div className="landing-container">
      {/* Retro grain texture overlay */}
      <div className="grain-overlay"></div>

      {/* Main Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          {/* App Name */}
          <h1 className="app-name">Eranos</h1>

          {/* Main Tagline */}
          <div className="tagline-wrapper">
            <h2 className="tagline-intro">No more thinking</h2>
            <h2 className="tagline-quote">"WHAT DO I BRING<br />TO THE POTLUCK?!"</h2>
          </div>

          {/* Brief Description */}
          <p className="description">
            See what everyone's bringing in real-time with AI recommendations
            that help you decide what to bring.
          </p>

          {/* App Store Badge */}
          <div className="cta-container">
            <a href="https://apps.apple.com/us/app/eranos/id6757322371" className="app-store-link">
              <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1728086400" alt="Download on the App Store" className="app-store-badge" />
            </a>
          </div>

          {/* Android Waitlist */}
          <div className="android-waitlist-section">
            <p className="android-waitlist-label">Interested in an Android version? Join the waitlist below.</p>
          </div>
          <div className="cta-container cta-waitlist">
            {status === 'success' ? (
              <div className="waitlist-success">
                <span className="waitlist-success-icon">✓</span>
                <p className="waitlist-success-text">You're on the list!</p>
              </div>
            ) : (
              <form className="waitlist-form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  className="waitlist-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (status === 'error') setStatus('idle');
                  }}
                  disabled={status === 'loading'}
                />
                <button
                  type="submit"
                  className="waitlist-btn"
                  disabled={status === 'loading'}
                >
                  {status === 'loading' ? 'Joining...' : 'Join Waitlist'}
                </button>
                {status === 'error' && (
                  <p className="waitlist-error">{errorMsg}</p>
                )}
              </form>
            )}
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <span className="contact-label">Questions?</span>
            <a href="mailto:geteranos@gmail.com" className="contact-email">
              geteranos@gmail.com
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-copyright">
            © 2026 Jayanth Putta
          </div>
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
<Link to="/support" className="footer-link">
              Support
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
